import React from 'react';
import { Col } from 'react-bootstrap';

import BlockWrapper from '../../../components/blocks/BlockWrapper';
import GenericBlock from '../../../components/blocks/GenericBlock';
import IconBlock from '../../../components/blocks/IconBlock';
import YoutubeVideoImage from "../../../components/YoutubeVideoImage";

export default class Strategy extends React.Component {

    constructor(props) {
        super(props);

        this.title = 'Strategy';
    }

    render() {
        return (
            <BlockWrapper id="strategy">
                <IconBlock className="hidden-xs hidden-sm" icon="screenshot">
                    <h3>{this.title}</h3>
                </IconBlock>

                <GenericBlock>
                    <div className="col-md-6 col-sm-12 col-xs-12">
                        <h4>{this.title}</h4>
                        <p>
                            There’s an unquestionable pattern of accelerating change today that almost every global company has to deal with. Consequently, learning is not only about ‘knowing’ but also about ‘doing’. TROI’s learning design support the involvement of many employees from all levels.
                        </p>

                        <h4>What clients say</h4>
                        <p>
                            <i>"I expect my employees to challenge our strategy. To make that happen we engage with TROI to create business videos. We also use the Challenge & Opportunity Video Format to share the results of our corporate dialogue."</i>
                        </p>
                        <p className="text-right"><i>Chief Executive Officer</i></p>
                    </div>

                    <Col md={6} sm={12} xs={12}>
                        <h4>Check out the video</h4>
                        <YoutubeVideoImage videoId="rJh596t03wQ" />
                        <div className="clearfix"></div>
                    </Col>
                </GenericBlock>
            </BlockWrapper>
        );
    }

}



// WEBPACK FOOTER //
// ./src/pages/parts/companies/Strategy.js